module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nfl/weekly-153f81f486f6812538eda01effd436c2.svg";